import { useState, useEffect } from 'react';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as gatewayService from '@frolight/services/api/gatewayService';

const useGatewayData = (gatewayId) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  useEffect(() => {
    let mounted = true;

    const getGatewayDataAbortController = new AbortController();
    const getGatewayData = async () => {
      if (mounted) setLoading(true);

      try {
        const gateway = await authenticatedAPIServiceCall(gatewayService.getGateway, {
          abortController: getGatewayDataAbortController,
          opts: { gatewayId: gatewayId }
        });
        if (gateway) {
          if (mounted) setData(gateway.data);
        } else {
          if (mounted) setError(new Error(`Error getting gateway with ID "${gatewayId}"`));
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          if (mounted) setError(err);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (gatewayId) {
      getGatewayData();
    }

    return () => {
      mounted = false;
      getGatewayDataAbortController.abort();
    }

  }, [ gatewayId ]);

  return { loading, error, data };
};

export default useGatewayData;